import React, { useState, useMemo, useEffect } from 'react';
import './Menu.css';
import HUDChat from '../Chat/Chat';
import HUDParticipants from '../Participants/Participants';
import Button from '../../primitives/Button/Button';

import { ReactComponent as ParticipantsIcon } from '../../../../assets/icon/people.svg';
import { ReactComponent as ChatIcon } from '../../../../assets/icon/feather-message-square.svg';
import HUDCameraControls from '../CameraControls/CameraControls';
import HUDSelfView from '../SelfView/SelfView';
import HUDCallControls from '../CallControls/CallControls';
import { ChatProvider } from '../../context/ChatContext';
import { useRoom, useParticipantCounts } from '@daily-co/daily-react';
import CopyableLabel from '../../primitives/CopyableLabel/CopyableLabel';
import { JOIN_ROOM_URL_PREFIX, JOIN_ROOM_URL_INFIX } from '../../../../utils/constants';
import HUDMediaControls from '../MediaControls/MediaControls';

const HUDMenu = () => {
  const [activeView, setActiveView] = useState<'chat' | 'participants' | null>('participants');
  const room = useRoom();

  /*
  If you want to only show participants view if joining an empty room, use this and set initial active view to null
  This leads to unnecessary re-renders as people join/leave
  const numParticipants = useRef(0);
  const { present, hidden } = useParticipantCounts();
  useEffect(() => {
    if (numParticipants.current === 0 && present === 1) setActiveView('participants');
    if (numParticipants.current === 0 && present > 1) setActiveView(null);
  }, [present]);
  */
  
  const toggleView = (view: 'chat' | 'participants') => {
    setActiveView(prevView => (prevView === view ? null : view));
  };

  return (
    <div className="hud-container">
      <div className="hud-menu-options">
        <Button onClick={() => toggleView('participants')} size="tiny" label="" icon={activeView === 'participants' ? <ParticipantsIcon className="icon-active" /> : <ParticipantsIcon />} />
        <Button onClick={() => toggleView('chat')} size="tiny" label="" icon={activeView === 'chat' ? <ChatIcon className="icon-active" /> : <ChatIcon />} />
      </div>
      <ChatProvider>
        {activeView && (
          <div className="hud-view">
            {room && <CopyableLabel value={room.name} copyValue={JOIN_ROOM_URL_PREFIX + JOIN_ROOM_URL_INFIX + room.name}/>}
            {activeView === 'chat' && <HUDChat />}
            {activeView === 'participants' && <HUDParticipants />}
          </div>
        )}
      </ChatProvider>
      <HUDCameraControls />
      <HUDSelfView />
      <HUDCallControls />
    </div>
  );
};

export default HUDMenu;
